import React from 'react';
import './LowboyTimesheet.scss';
import {
    Button,
    Input,
    InputGroup,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCancel, faHandPointLeft } from '@fortawesome/free-solid-svg-icons';
import { FormLabel } from '@mui/material';
import { TimesheetStatus } from '../timesheet/Timesheet';

export default class LowboyTimesheetRejectionButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            rejectionNotes: '',
        };
    }

    isApproveButtonVisible = () => {
        const { isAdmin, isTimesheetApprover, lowboyTimesheet, anyChanges } =
            this.props;

        if (!isAdmin || anyChanges || !lowboyTimesheet) {
            return false;
        }

        if (!isTimesheetApprover) {
            return (
                lowboyTimesheet.timesheetStatusId < TimesheetStatus.Validated
            );
        }

        return lowboyTimesheet.timesheetStatusId < TimesheetStatus.Approved;
    };

    getCanEnterEditMode = () => {
        const { lowboyTimesheet, isAdmin, isTimesheetApprover, adminEditMode } =
            this.props;

        if (
            !lowboyTimesheet ||
            !isAdmin ||
            adminEditMode ||
            lowboyTimesheet.timesheetStatusId == TimesheetStatus.Rejected
        ) {
            return false;
        }

        if (isTimesheetApprover) {
            return (
                lowboyTimesheet.timesheetStatusId <= TimesheetStatus.Validated
            );
        }

        return lowboyTimesheet.timesheetStatusId <= TimesheetStatus.Submitted;
    };

    canReject = () => {
        const { lowboyTimesheet, isAdmin } = this.props;

        return (
            isAdmin &&
            lowboyTimesheet &&
            !lowboyTimesheet.anyAdjustmentsMade &&
            lowboyTimesheet.timesheetStatusId == TimesheetStatus.Submitted
        );
    };

    onToggleModal = () => {
        const { saving } = this.props;

        if (saving) {
            return;
        }

        const { showModal } = this.state;

        this.setState({ showModal: !showModal, rejectionNotes: null });
    };

    initiateRejection = () => {
        const { rejectionNotes } = this.state;

        const { onReject } = this.props;

        onReject(rejectionNotes);
    };

    render() {
        const { loading, isAdmin, isReadOnly, saving } = this.props;

        const { showModal, rejectionNotes } = this.state;

        if (loading || (!isAdmin && isReadOnly) || !this.canReject()) {
            return null;
        }

        const rejectionNotesInsufficient =
            !rejectionNotes ||
            rejectionNotes.length < 10 ||
            rejectionNotes.length > 500;

        return (
            <>
                <Button
                    className="w-50 mb-2"
                    color="danger"
                    type="button"
                    onClick={this.onToggleModal}
                >
                    <FontAwesomeIcon icon={faHandPointLeft} className="mr-2" />
                    Return for Adjustments
                </Button>

                <Modal isOpen={showModal} toggle={this.onToggleModal} size="lg">
                    <ModalHeader toggle={this.onToggleModal}>
                        Rejecting Timesheet - Notes Needed
                    </ModalHeader>
                    <ModalBody>
                        <div>
                            Please provide some feedback explaining the reason
                            for this timesheet's rejection. Please remember that
                            this will be visible to the employee.
                        </div>

                        <InputGroup>
                            <FormLabel text="Rejection Note" />

                            <Input
                                type="textarea"
                                value={rejectionNotes || ''}
                                onChange={(e) =>
                                    this.setState({
                                        rejectionNotes: e.target.value,
                                    })
                                }
                                maxLength={500}
                                max={500}
                                invalid={rejectionNotesInsufficient}
                            />
                        </InputGroup>
                    </ModalBody>
                    <ModalFooter>
                        <div className="mr-auto">
                            <Button
                                type="button"
                                color="warning"
                                outline
                                onClick={this.onToggleModal}
                                disabled={saving}
                            >
                                <FontAwesomeIcon
                                    icon={faCancel}
                                    className="mr-1"
                                />
                                Cancel
                            </Button>
                        </div>
                        <div>
                            <Button
                                type="button"
                                outline={rejectionNotesInsufficient}
                                disabled={rejectionNotesInsufficient || saving}
                                onClick={this.initiateRejection}
                                color="success"
                            >
                                <FontAwesomeIcon
                                    icon={faHandPointLeft}
                                    className="mr-1"
                                />
                                Return To Employee
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}
